import { USER } from "./types";

export function setUser(userData = {}) {
	return {
		payload: userData,
		type: USER
	};
}
